import React from 'react'
import realmData from './data/RealmData'
import ClubTeaser from './ClubTeaser'

/*
The ClubTeaserList displays a listing of ClubTeasers.
It takes the following props:
clubs: an array of clubs
onDetailsClicked: a callback function to call when club details are clicked on.
*/
export default class ClubTeaserList extends React.Component {
  constructor(props){
    super(props)

    this.listContainer = React.createRef()

    var w = window,
        d = document,
        documentElement = d.documentElement,
        body = d.getElementsByTagName('body')[0],
        width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
        //console.log(width)
    this.state = {
      showAll: false,
      width: width
    }
  }

  toggleAllClubs(){
    this.setState({
      showAll: !this.state.showAll
    })
  }

  componentDidMount(){

    if (this.props.clubs && this.props.clubs.length > 0){
      this.listContainer.current.focus();
    }
  }

  render(){
    let firstClubs =  [];
    //if (this.state.width < 640 && this.props.clubs){
    //  firstClubs = _.take(this.props.clubs, 2)
    //} else {
      firstClubs = this.props.clubs;
    //}

    let lastClubs = null;
    /*
    if (this.props.clubs && this.props.clubs.length > 2 && this.state.width < 640){
      lastClubs = _.takeRight(this.props.clubs, this.props.clubs.length - 2)
    }*/

    return (
      <div className="club-teasers-list" ref={this.listContainer} tabIndex="0">
        {firstClubs &&
          firstClubs.map((club, index) =>
          <ClubTeaser
            key={club.key}
            club={club}
            center={this.props.center}
            onDetailsClicked={this.props.onDetailsClicked.bind(this)}
          />
          )}
          {lastClubs && ! this.state.showAll &&
            <div className="more-clubs-container center">
              <a onClick={() => this.toggleAllClubs()} className="more-clubs-link">
                {lastClubs.length > 1 &&
                  <h3 className="red">Show {lastClubs.length} more centres</h3>
                }
                {lastClubs.length == 1 &&
                  <h3 className="red">Show {lastClubs.length} more centre</h3>
                }
              </a>
            </div>
          }
          {lastClubs && this.state.showAll &&
            lastClubs.map((club, index) =>
            <ClubTeaser
              key={club.key}
              club={club}
              center={this.props.center}
              onDetailsClicked={this.props.onDetailsClicked}
            />

            )}
          {lastClubs && this.state.showAll &&
            <div className="more-clubs-container center">
              <a onClick={() => this.toggleAllClubs()} className="more-clubs-link">
                <h3 className="red">Show first 2 centres</h3></a>
            </div>
          }
      </div>
    )
  }
}
